import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function gsapTransform() {
    gsap.registerPlugin(ScrollTrigger);


    const figures = document.querySelectorAll('.video-block');

    figures.forEach(figure => {
        const video = figure.querySelector("video");
        // Initial style (circle)
        gsap.set(figure, {
            borderRadius: "100%",
            width: "100vw", // Adjust for your layout
            height: "100vh",
            overflow: "hidden",
            position: "relative",
            border: "none",
        });

        gsap.set(video, {
            position: "absolute",    // fixed-like inside figure
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            border: "none",
            y: "0%" // start parallax at normal position
        });


        ScrollTrigger.create({
            trigger: figure,
            start: "top 60%",
            end: "bottom 40%",
            scrub: true,
            onEnter: () => {
                // Animate to rectangle and play
                gsap.to(figure, {
                    borderRadius: "0%",
                    width: "100vw",
                    height: "100vh",
                    duration: 0.8,
                    ease: "power1.out"
                });
                video.play();
            },
            onLeave: () => {
                // Animate back to circle and pause
                gsap.to(figure, {
                    borderRadius: "100%",
                    duration: 0.8,
                    ease: "power1.in"
                });
                video.pause();
            },
            onEnterBack: () => {
                // When scrolling back up into view
                gsap.to(figure, {
                    borderRadius: "0%",
                    width: "100vw",
                    height: "100vh",
                    duration: 0.8,
                    ease: "power1.out"
                });
                video.play();
            },
            onLeaveBack: () => {
                // When scrolling back up out of view
                gsap.to(figure, {
                    borderRadius: "100%",
                    duration: 0.8,
                    ease: "power1.in"
                });
                video.pause();
            }
        });

        ScrollTrigger.create({
            trigger: figure,
            start: "top 50px",    // when figure hits the very top
            end: "+=300vh",        // how long to keep it pinned
            pin: true,
            pinSpacing: true,   // optional: prevent extra space after unpin
        });

        gsap.to(video, {
            y: "100%", // video moves inside pinned figure
            ease: "none",
            scrollTrigger: {
                trigger: figure,
                start: "top top",
                end: "+=1000vh",
                scrub: true
            }
        });
    });
}